import { CAPABILITIES } from "../../auth/permissions";

export const CUSTOMER_OVERVIEW_TABS = [
  { id: "card", label: "Customer Card", capability: CAPABILITIES.customersRead },
  { id: "notes", label: "Notes", capability: CAPABILITIES.customersCardWrite },
  { id: "contacts", label: "Contacts", capability: CAPABILITIES.customersCardWrite },
  { id: "logins", label: "Logins", capability: CAPABILITIES.customersCardWrite },
  { id: "documents", label: "Documents", capability: CAPABILITIES.customersDocuments },
  { id: "claims", label: "Claims", capability: CAPABILITIES.claimsWrite },
  { id: "invoices", label: "Invoices", capability: CAPABILITIES.invoicesWrite },
  { id: "excise", label: "Excise Claims", capability: CAPABILITIES.claimsWrite },
  { id: "financial", label: "Financial", capability: CAPABILITIES.prefinanceRead },
  { id: "pricing", label: "Pricing Agreements", capability: CAPABILITIES.customersPricing },
  { id: "settings", label: "Customer Settings", capability: CAPABILITIES.customersEdit },
];

export const LEGACY_CUSTOMER_TAB_IDS = [
  "card",
  "notes",
  "contacts",
  "services",
  "logins",
  "documents",
  "claims",
  "invoices",
  "excise",
  "licensePlates",
  "financial",
  "pricing",
  "settings",
];

export const getVisibleCustomerTabs = (hasPermission) =>
  CUSTOMER_OVERVIEW_TABS.filter((tab) => hasPermission(tab.capability, tab.minLevel || "R"));

export const resolveCustomerTabId = (rawTab, visibleTabs) => {
  const visibleIds = visibleTabs.map((tab) => tab.id);
  if (visibleIds.length === 0) {
    return null;
  }

  if (rawTab == null || rawTab === "") {
    return visibleIds[0];
  }

  const raw = String(rawTab);
  const fromLegacyIndex = /^\d+$/.test(raw) ? LEGACY_CUSTOMER_TAB_IDS[Number(raw)] : null;
  const requestedId = fromLegacyIndex || raw;

  if (visibleIds.includes(requestedId)) {
    return requestedId;
  }

  return visibleIds[0];
};
